/*eslint-disable */
import root from '../_helpers/roots';
let mediaListUrlLink = root.mediaListLink.link;
import Vue from 'vue'
import axios from 'axios';
export default {
  state: {
    mediaListDetails: {},
    mediaListDetailsById: {}
  },
  mutations: {
    getMediaListMutation(state, value) {
      Vue.set(state, 'mediaListDetails', value)
    },
    getMediaDetailsMutation(state, value) {
      Vue.set(state, 'mediaListDetailsById', value)
    },
  },
  actions: {
    getMediaListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(mediaListUrlLink).then(res => {
          context.commit('getMediaListMutation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    getMediaDetailsByIdFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(mediaListUrlLink + payload.id).then(res => {
          context.commit('getMediaDetailsMutation', res.data);
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
  },
  getters: {
    mediaListDetailsState: state => state.mediaListDetails,
    mediaListDetailsByIdState: state => state.mediaListDetailsById
  }
}